import type { PatternProps } from "./shared";

export function WavesPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-wavesPattern`}
				patternUnits="userSpaceOnUse"
				width="35"
				height="17.5"
			>
				<path
					d="M0 8.75 Q 8.75 0, 17.5 8.75 T 35 8.75"
					fill="none"
					stroke={color}
					strokeWidth="3.5"
				/>
			</pattern>
		</defs>
	);
}
